import {
  fetchPaymentDetail,
  downloadInvoice,
  downloadReceipt,
  updateBaddebt,
  updatePayment,
} from "src/pages/Payment/redux/detail";
import { format, evaluate, round, sum } from "mathjs";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { withComma, fixed2 } from "src/features/Utils/price";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import capitalize from "lodash/capitalize";
import Chip from "src/pages/Payment/List/Chip.js";
import Collapse from "@material-ui/core/Collapse";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Divider from "@material-ui/core/Divider";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FaceIcon from "@material-ui/icons/Face";
import get from "lodash/get";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import includes from "lodash/includes";
import Layout from "src/features/Layout";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import map from "lodash/map";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import Paper from "@material-ui/core/Paper";
import PhoneIcon from "@material-ui/icons/Phone";
import React, { Fragment, useEffect, useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableHeadCell from "src/pages/Payment/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import union from "lodash/union";
import MuiChip from "@material-ui/core/Chip";

const INVOICE_ACCEPT = ["ready", "paid", "bad_debt"];

function Row({ config }) {
  const [open, setOpen] = useState(false);
  const _id = get(config, "_id", "");
  const station_name = get(config, "station.full_name", "");
  const medicine_wait = get(config, "medicine_wait", []);
  const medicine_ready = get(config, "medicine_ready", []);
  const supply_wait = get(config, "supply_wait", []);
  const supply_ready = get(config, "supply_ready", []);
  const status = capitalize(get(config, "status", ""));
  const total_medicine = union(medicine_wait, medicine_ready).length;
  const total_supply = union(supply_wait, supply_ready).length;
  const total_price = withComma(fixed2(get(config, "total_price", 0)));

  const bundle = get(config, "bundle");
  const discount = withComma(fixed2(get(config, "bundle.discount", 0)));
  const remark = get(config, "remark","");

  return (
    <Fragment>
      <TableRow>
        <TableCell component="th" scope="row">
          {_id}
        </TableCell>
        <TableCell>{station_name}</TableCell>
        <TableCell>฿{discount}</TableCell>
        <TableCell>฿{total_price}</TableCell>
        <TableCell>{status}</TableCell>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box my={2}>
              <Typography variant="h6" gutterBottom component="div">
                Medicine ({total_medicine})
              </Typography>
              <Table size="small" aria-label="medicines">
                <TableHead>
                  <TableRow>
                    <TableCell>Status</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Package</TableCell>
                    <TableCell align="right">Price/Unit</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell align="right">Total Price</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {medicine_wait.map((record) => {
                    const pkg_id = get(record, "package._id");
                    const name = get(
                      record,
                      "package.presentation.search_name",
                      ""
                    );
                    const multiplier = get(record, "package.multiplier", "");
                    const presentation_name = get(
                      record,
                      "package.presentation.presentation_name.name",
                      ""
                    );
                    const presentation_quantity = get(
                      record,
                      "package.presentation.quantity",
                      ""
                    );
                    const presentation_unit = get(
                      record,
                      "package.presentation.presentation_unit.name",
                      ""
                    );
                    const container = get(record, "package.container.name", "");
                    const price = get(record, "is_promo", false)
                      ? get(record, "promo_price", 0)
                      : get(record, "price", 0);
                    const quantity = get(record, "quantity", 0);
                    const total_price = withComma(
                      format(round(evaluate(`${price}*${quantity}`), 2), {
                        notation: "fixed",
                        precision: 2,
                      })
                    );
                    return (
                      <TableRow key={`med-wait-${pkg_id}`}>
                        <TableCell component="th" scope="row">
                          Pre-Order
                        </TableCell>
                        <TableCell>{name}</TableCell>
                        <TableCell>
                          {multiplier} {presentation_name} x{" "}
                          {presentation_quantity} {presentation_unit} /{" "}
                          {container}
                        </TableCell>
                        <TableCell align="right">฿{price}</TableCell>
                        <TableCell>{quantity}</TableCell>
                        <TableCell align="right">฿{total_price}</TableCell>
                      </TableRow>
                    );
                  })}

                  {medicine_ready.map((record) => {
                    const pkg_id = get(record, "package._id");
                    const name = get(
                      record,
                      "package.presentation.search_name",
                      ""
                    );
                    const multiplier = get(record, "package.multiplier", "");
                    const presentation_name = get(
                      record,
                      "package.presentation.presentation_name.name",
                      ""
                    );
                    const presentation_quantity = get(
                      record,
                      "package.presentation.quantity",
                      ""
                    );
                    const presentation_unit = get(
                      record,
                      "package.presentation.presentation_unit.name",
                      ""
                    );
                    const container = get(record, "package.container.name", "");
                    const price = get(record, "is_promo", false)
                      ? get(record, "promo_price", 0)
                      : get(record, "price", 0);
                    const quantity = sum(
                      map(get(record, "lot_detail", []), "quantity")
                    );
                    const total_price = withComma(
                      format(round(evaluate(`${price}*${quantity}`), 2), {
                        notation: "fixed",
                        precision: 2,
                      })
                    );

                    return (
                      <TableRow key={`med-ready-${pkg_id}`}>
                        <TableCell component="th" scope="row">
                          Ready
                        </TableCell>
                        <TableCell>{name}</TableCell>
                        <TableCell>
                          {multiplier} {presentation_name} x{" "}
                          {presentation_quantity} {presentation_unit} /{" "}
                          {container}
                        </TableCell>
                        <TableCell align="right">฿{price}</TableCell>
                        <TableCell>{quantity}</TableCell>
                        <TableCell align="right">฿{total_price}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
            <Box my={2}>
              <Typography variant="h6" gutterBottom component="div">
                Supply ({total_supply})
              </Typography>
              <Table size="small" aria-label="medicines">
                <TableHead>
                  <TableRow>
                    <TableCell>Status</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Package</TableCell>
                    <TableCell align="right">Price/Unit</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell align="right">Total Price</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {supply_wait.map((record) => {
                    const pkg_id = get(record, "package._id");
                    const name = get(record, "package.supply.search_name", "");
                    const multiplier = get(record, "package.multiplier", "");
                    const container = get(record, "package.container.name", "");
                    const price = get(record, "is_promo", false)
                      ? get(record, "promo_price", 0)
                      : get(record, "price", 0);
                    const quantity = get(record, "quantity", 0);
                    const total_price = withComma(
                      format(round(evaluate(`${price}*${quantity}`), 2), {
                        notation: "fixed",
                        precision: 2,
                      })
                    );

                    return (
                      <TableRow key={pkg_id}>
                        <TableCell component="th" scope="row">
                          Pre-Order
                        </TableCell>
                        <TableCell>{name}</TableCell>
                        <TableCell>
                          {multiplier} {container}
                        </TableCell>
                        <TableCell align="right">฿{price}</TableCell>
                        <TableCell>{quantity}</TableCell>
                        <TableCell align="right">฿{total_price}</TableCell>
                      </TableRow>
                    );
                  })}

                  {supply_ready.map((record) => {
                    const pkg_id = get(record, "package._id");
                    const name = get(record, "package.supply.search_name", "");
                    const multiplier = get(record, "package.multiplier", "");
                    const container = get(record, "package.container.name", "");
                    const price = get(record, "is_promo", false)
                      ? get(record, "promo_price", 0)
                      : get(record, "price", 0);
                    const quantity = sum(
                      map(get(record, "lot_detail", []), "quantity")
                    );
                    const total_price = withComma(
                      format(round(evaluate(`${price}*${quantity}`), 2), {
                        notation: "fixed",
                        precision: 2,
                      })
                    );

                    return (
                      <TableRow key={pkg_id}>
                        <TableCell component="th" scope="row">
                          Ready
                        </TableCell>
                        <TableCell>{name}</TableCell>
                        <TableCell>
                          {multiplier} {container}
                        </TableCell>
                        <TableCell align="right">฿{price}</TableCell>
                        <TableCell>{quantity}</TableCell>
                        <TableCell align="right">฿{total_price}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
            {bundle && (
              <Box my={2}>
                <Typography variant="h6" gutterBottom component="div">
                  Bundle
                </Typography>
                <Table size="small" aria-label="medicines">
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell align="right">Amount</TableCell>
                      <TableCell align="right">Discount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {get(bundle, "name")}
                      </TableCell>
                      <TableCell align="right">
                        {get(bundle, "amount")}
                      </TableCell>
                      <TableCell align="right">
                        ฿{get(bundle, "discount")}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            )}
             <Box my={2}>
              <Typography variant="body1" gutterBottom component="div">
                Remark : {remark}
              </Typography>
              </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
}

function PaymentDetail() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const fetching = useSelector((state) => state.payment.detail.fetching);
  // eslint-disable-next-line
  const error = useSelector((state) => state.payment.detail.error);
  const data = useSelector((state) => state.payment.detail.data);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [openBaddebtModal, setOopenBaddebtModal] = useState(false);

  const order_no = get(data, "slug.order", "");
  const order_date = get(data, "create_date", null);
  const first_name = get(data, "account.first_name", "");
  const last_name = get(data, "account.last_name", "");
  const contact = `${first_name} ${last_name}`;
  const name = get(data, "account.mall.name", "");
  const status = get(data, "payment_status", "");
  const phone = get(data, "account.mobile", "");
  const sub_order = get(data, "sub_order", []);
  /* ship-address */
  const ship_line1 = get(data, "shipping_address.line1", "");
  const ship_sub_district = get(data, "shipping_address.sub_district", "");
  const ship_district = get(data, "shipping_address.district", "");
  const ship_province = get(data, "shipping_address.province", "");
  const ship_postal_code = get(data, "shipping_address.province", "");
  const shipping_address = `${ship_line1} ${ship_sub_district} ${ship_district} ${ship_province} ${ship_postal_code}`;

  const creator_first_name = get(data, "create_by.first_name", "");
  const creator_last_name = get(data, "create_by.last_name", "");
  const create_by = `${creator_first_name} ${creator_last_name}`;
  const remark = get(data, "remark", "");


  /* request tax invoice */
  const request_tax = get(data, "request_tax_invoice", false);

  /* active-button */
  const invoice_active = includes(INVOICE_ACCEPT, status);
  const receipt_active = status === "paid";
  const confirm_active = status === "ready";

  useEffect(() => {
    dispatch(fetchPaymentDetail(id));
  }, [dispatch, id]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const confirmPayment = async () => {
    try {
      await dispatch(updatePayment(id));
    } catch (error) {
      console.log("confirmPayment -> error", error);
    }
  };

  const confirmBaddebtModal = async () => {
    try {
      await dispatch(updateBaddebt(id));
    } catch (error) {
      // มี error
      setOopenBaddebtModal(false);
    }
  };

  const cancelBaddebtModal = () => {
    setOopenBaddebtModal(false);
  };

  const handleBaddebtClick = () => {
    if (status === "ready") {
      setOopenBaddebtModal(true);
    }
  };

  const handleInvoiceClick = async () => {
    try {
      await dispatch(downloadInvoice(order_no, id));
    } catch (error) {
      console.error(error);
    }
  };

  const handleReceiptClick = async () => {
    try {
      await dispatch(downloadReceipt(order_no, id));
    } catch (error) {
      console.error(error);
    }
  };

  if (fetching) {
    return <Layout>Loading...</Layout>;
  }

  return (
    <Layout>
      <Dialog
        open={openBaddebtModal}
        onClose={() => {}}
        aria-labelledby="bad-debt-dialog"
        aria-describedby="bad-debt-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="bad-debt-dialog-description">
            Change the status of {name}:{order_no} to Bad-debt?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelBaddebtModal} color="primary">
            CANCEL
          </Button>
          <Button onClick={confirmBaddebtModal} color="primary" autoFocus>
            CHANGE
          </Button>
        </DialogActions>
      </Dialog>
      <Box component={Paper} elevation={0}>
        <Grid
          container
          spacing={0}
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Grid item xs={8}>
            <Box py={3} pl={3}>
              <Box fontSize="h6.fontSize">{name}</Box>
              <Box display="flex" alignItems="center" my={1}>
                <LocationOnIcon color="disabled" fontSize="small" />
                <Box ml={0.5}>{shipping_address}</Box>
              </Box>
              <Box display="flex" alignItems="center" my={1}>
                <FaceIcon color="disabled" fontSize="small" />
                <Box ml={0.5}>{contact}</Box>
              </Box>
              <Box display="flex" alignItems="center" my={1}>
                <PhoneIcon color="disabled" fontSize="small" />
                <Box ml={0.5}>{phone}</Box>
              </Box>
              {request_tax && (
                <Box display="flex" alignItems="center" my={1}>
                  <MuiChip color="secondary" label="Request Tax Invoice" />
                </Box>
              )}
            </Box>
          </Grid>
          <Divider orientation="vertical" flexItem />
          <Grid item xs={3}>
            <Box py={3} pr={3}>
              <Box display="flex" alignItems="center" mb={1}>
                <Chip title={status} status={status} />
              </Box>
              <Box display="flex" alignItems="center" my={1}>
                Order Number: {order_no}
              </Box>
              <Box display="flex" alignItems="center" my={1}>
                {moment(order_date).format("DD/MM/YYYY, HH:mm:ss")}
              </Box>
              <Box display="flex" alignItems="center" my={1}>
                Create By: {create_by}
              </Box>
              <Box display="flex" alignItems="center" my={1}>
                Remark : {remark}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        my={2}
      >
        <Box fontSize="subtitle2.fontSize">{sub_order.length} Sub-Order(s)</Box>
        <Box display="flex">
          <Box mr={2}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleInvoiceClick}
              disabled={!invoice_active}
            >
              Invoice
            </Button>
          </Box>
          <Box mr={2}>
            <Button
              variant="contained"
              onClick={handleReceiptClick}
              disabled={!receipt_active}
            >
              RECEIPT
            </Button>
          </Box>
          <Box>
            <Button
              variant="contained"
              aria-controls="more-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreHorizIcon />
            </Button>
            <Menu
              id="more-menu"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              getContentAnchorEl={null}
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleBaddebtClick}>Bad Debt</MenuItem>
            </Menu>
          </Box>
        </Box>
      </Box>
      <Box component={Paper} p={3} elevation={0}>
        <TableContainer component={Paper} elevation={0}>
          <Table aria-label="sub-order-table">
            <TableHead>
              <TableRow>
                <TableHeadCell>Sub-Order No.</TableHeadCell>
                <TableHeadCell>Station</TableHeadCell>
                <TableHeadCell>Discount</TableHeadCell>
                <TableHeadCell>Total Price</TableHeadCell>
                <TableHeadCell>Status</TableHeadCell>
                <TableHeadCell>Detail</TableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sub_order.map((record) => (
                <Row key={record._id} config={record} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box display="flex" justifyContent="center" alignItems="center" py={2}>
        <Button
          variant="contained"
          color="secondary"
          onClick={confirmPayment}
          disabled={!confirm_active}
        >
          CONFIRM PAYMENT
        </Button>
      </Box>
    </Layout>
  );
}

export default PaymentDetail;
